import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from '@/components/atoms/Spinner';
import { useAuth } from '@/hooks/useAuth';
import { usePrefersAdminExperience } from '@/hooks/usePrefersAdminExperience';
import { getHomeRoute } from '@/utils/roleRouting';
import { ROUTES } from '@/constants/routes';
import styles from './AppEntryPage.module.scss';

/**
 * Punto de entrada del deep link `/app` (botones "Empezar ahora" / "Seguir
 * aprendiendo" de los emails de bienvenida y resumen semanal).
 *
 * Por qué una página real y no un `<Navigate>` directo: cuando el deep link
 * abre la app en frío, `deepLinks.ts` fija `window.location.hash = '#/app'`. Si
 * el elemento de `/app` fuese un `<Navigate>` (que renderiza `null` mientras
 * redirige), la cadena de redirecciones no asienta con el hash puesto a mano y
 * la pantalla se queda en blanco. Renderizando un spinner **visible** y
 * navegando una sola vez con `useNavigate` (imperativo) tras resolver el auth,
 * el router siempre muestra algo y la transición es limpia.
 */
export function AppEntryPage() {
  const navigate = useNavigate();
  const { user, isAuthenticated, isLoading } = useAuth();
  const prefersAdmin = usePrefersAdminExperience();

  useEffect(() => {
    // Esperamos a que el auth resuelva para no mandar a login a un usuario que
    // sí tiene sesión persistida.
    if (isLoading) return;
    const destination =
      isAuthenticated && user ? getHomeRoute(user, prefersAdmin) : ROUTES.AUTH.LOGIN;
    navigate(destination, { replace: true });
  }, [isLoading, isAuthenticated, user, prefersAdmin, navigate]);

  return (
    <div className={styles.appEntry}>
      <Spinner size="lg" aria-label="Cargando" />
    </div>
  );
}

export default AppEntryPage;
